// Долги одного человека: один запрос на весь продукт.
//
// Живёт в общем слое, потому что спрашивают его ДВА раздела. «Люди» → карточка → вкладка
// «Долги» показывает их целиком, с заведением и списанием. «Деньги» → карточка подотчётного
// лица показывает свод и уводит туда же.
//
// Свой хук в каждом разделе означал бы два ключа кэша на один ответ — то есть две суммы
// долга у одного человека на соседних экранах, расходящиеся ровно тогда, когда одну из них
// сбросили, а другую нет. Для системы, где по этой сумме решают, доплачивать или удерживать,
// это дороже любого удобства.

import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import type { DebtOut } from '@/shared/api/endpoints/losses';
import { fetchEmployeeDebts } from '@/shared/api/endpoints/losses';
import type { ListResponse } from '@/shared/api/types';
import type { ApiError } from '@/shared/errors/api-error';

/** Ключ кэша долгов человека. Один на продукт: по нему же их и сбрасывают. */
export function ключДолгов(employeeId: string): readonly unknown[] {
  return ['people', 'debts', employeeId];
}

export function useEmployeeDebts(
  employeeId: string | null,
): UseQueryResult<ListResponse<DebtOut>, ApiError> {
  return useQuery<ListResponse<DebtOut>, ApiError>({
    queryKey: ключДолгов(employeeId ?? 'нет'),
    queryFn: () => fetchEmployeeDebts(employeeId!),
    enabled: employeeId !== null,
  });
}
